<script type="text/ecmascript-6">
    import DesignerQuestionFrameColourExternal from "../DesignerQuestionFrameColourExternal.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionFrameColourExternal,
            TileQuestion
        ],
        props: {
            frameMaterial: {
                default(){
                    return '';
                }
            },
            slab: {
                required: true,
            },
            profile: {
                required: true,
            },
            doorRange: {
                required: true,
            },
            colourRange: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            thumbURL(){
                if (this.frameMaterial !== '') {
                    return '/thumb/frame-colour-' + this.frameMaterial + '/';
                } else {
                    return '/thumb/frame-colour/';
                }
            },
            passed_filter(){
                return this.variable_ready(this.frameMaterial, this.slab, this.profile, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/frame-colour-external?frame_material=' + this.frameMaterial + '&slab=' + this.slab + '&colour_range=' + this.colourRange;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.slab + '_' + this.colourRange;
            },
        },
        watch: {
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'colourRange': function (val, oldVal) {
                this.update_options();
            },
        },
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_col) => {
                this.localTarget = new_col;
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
